namespace app.model.project {
  export enum ProjectType {
    account = "account_project",
    organization = "organization_project"
  }
}

